import logger from "./logging";

export interface APIError {
  message: string;
  fieldErrors: { [k: string]: string };
  body: Error | null;
}

export const adaptDjangoErrors = (errs: {
  [k: string]: string[];
}): { [k: string]: string } | null => {
  const extractError = (out: { [k: string]: string }, [k, vs]: [string, any]) => {
    if (vs instanceof Array) {
      const v = vs[0];
      if (k === "nonFieldErrors") {
        return { ...out, _error: v };
      }

      return { ...out, [k]: v };
    } else if (typeof vs !== "string") {
      return { ...out, [k]: adaptDjangoErrors(vs) };
    }
    // Some other shit got passed in
    logger.error("Invalid value:", vs);
    return out;
  };
  if (typeof errs === "string") {
    logger.error(errs);
    return null;
  }
  return Object.entries(errs).reduce(extractError, {});
};
